<template>
  <PageWrapper
    cardClass="shadow-none"
    isChildWrapper
    isDense
    :isLoading="isLoading"
  >
    <template #title> جزئیات معرفی استاد </template>
    <BRow>
      <BCol cols="12">
        <CustomEditor
          label="متن معرفی استاد"
          v-model="masterIntro.description"
        ></CustomEditor>
      </BCol>
      <BCol cols="12">
        <TextInput
          inputLabel="تحصیلات"
          v-model="masterIntro.education"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          customRules="min:1|max:100"
          inputLabel="میزان رضایتمندی"
          :numberOnly="true"
          type="number"
          :min="0"
          :max="5"
          inputMode="numeric"
          v-model="masterIntro.satisfactionRate"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          inputLabel="هشتگ"
          v-model="masterIntro.hashtag"
          @input="onHashtagInput"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <BFormGroup label="ویدیو معرفی استاد" label-for="imageFile">
          <BFormFile
            v-model="uploadVideoPayload.imageFile"
            @input="uploadMasterVideo()"
            ref="imageFile"
            id="imageFile"
            accept=".mp4"
          ></BFormFile>
        </BFormGroup>
      </BCol>
      <BCol cols="12" v-if="uploaded">
        <p class="mb-0">در حال آپلود {{ uploaded + "%" }}</p>
        <b-progress animated v-model="uploaded" max="100" />
      </BCol>
      <BCol cols="6" v-if="masterIntro.videoList">
        <video
          height="200px"
          preload="metadata"
          class="rounded-lg"
          controls
          :src="masterIntro.videoList[0]"
          style="width: 100%; max-height: 20rem"
        ></video>
      </BCol>
      <BCol cols="12">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <BButton variant="success" class="ml-auto" @click="updateMasterIntro">
            بروزرسانی معرفی
          </BButton>
        </div>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    masterUserId: {
      type: [String, Number],
      required: false,
    },
    currentMasterIntro: {
      type: Object,
      required: false,
    },
  },
  emits: ["refetch"],

  data() {
    return {
      isLoading: false,
      uploaded: null,
      masterIntro: {
        description: null,
        videoList: [],
        satisfactionRate: null,
        education: null,
        teachingExperience: 0,
        hashtag: "",
      },
      uploadVideoPayload: {
        imageFile: null,
        fileType: 2,
        title: null,
        alt: null,
        description: null,
      },
    };
  },
  methods: {
    onHashtagInput(e) {
      const value = e;
      this.masterIntro.hashtag = value.replace(
        /[^a-zA-Z0-9_\-\u0600-\u06FF]/g,
        ""
      );
    },

    GetInfoProfileMaster() {
      try {
        const req = new GetInfoProfileMasterForAdmin(this);
        req.setRequestParam({ masterUserId: this.masterUserId });

        req.fetch((res) => {
          if (res.isSuccess) this.masterIntro = res.data;
          else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateMasterIntro() {
      // if (this.uploadVideoPayload.imageFile) {
      //   await this.uploadMasterVideo();
      // }
      try {
        this.isLoading = true;

        const _this = this;

        _this.masterIntro.masterUserId = _this.masterUserId;
        _this.masterIntro.teachingExperience = 0;
        const updateMasterIntro = new SetInfoProfileMaster(_this);

        // updateMasterIntro.setRequestParamDataObj({
        //   userId: _this.masterUserId,
        // });

        updateMasterIntro.setRequestParamDataObj(_this.masterIntro);

        await updateMasterIntro.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "جزئیات معرفی استاد ویرایش شد",
              },
            });
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: response.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async generateVideoFormData() {
      return new Promise((resolve, reject) => {
        this.uploadVideoPayload.title = "";
        this.uploadVideoPayload.alt = "";
        this.uploadVideoPayload.description = "";

        const myFormData = new FormData();
        Object.keys(this.uploadVideoPayload).forEach((key) => {
          myFormData.append(key, this.uploadVideoPayload[key]);
        });
        resolve(myFormData);
      });
    },

    async uploadMasterVideo() {
      try {
        const _this = this;
        const uploadImage = new UploadImage(_this);
        uploadImage.setFormData(await _this.generateVideoFormData());
        await uploadImage.sendFormData((res) => {
          if (res.data.url) {
            _this.uploaded = null;
            _this.masterIntro.videoList = [res.data.url];
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.GetInfoProfileMaster();
  },
  components: {
    BRow,
    BCol,
    BButton,
    PageWrapper,
    BFormGroup,
    BFormFile,
    CustomEditor,
    TextInput,
    BProgress,
  },
};
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormFile,
  BProgress,
} from "bootstrap-vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomEditor from "@/views/components/Utils/CustomEditor.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { UploadImage } from "@/libs/Api/Uploader";
import TextInput from "@/views/components/Utils/TextInput.vue";
import {
  SetInfoProfileMaster,
  GetInfoProfileMasterForAdmin,
} from "@/libs/Api/Master";
</script>
